/* src/app/private/components/tickets/bulk-action/bulk-action.component.scss */
/*# sourceMappingURL=bulk-action.component.css.map */
